import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult, DataSourceRequestState } from '@progress/kendo-data-query';
import { Observable } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { AppConstant } from "src/app/app.constant";

@Injectable({
    providedIn: 'root'
  })
  export class PermissionSetService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor( private httpClient: HttpClient,
        private appConstant: AppConstant,
        ) {
      this.apiUrl = this.appConstant.getUrl();
    }
    managePermissionSet(section) {
      return this.httpClient.post(`${this.apiUrl}/managePermissionSet`, section).pipe(
        map((response: any) => {
          return response;
        })
      )
    }
    deletePermissionSet(id: number) {
      return this.httpClient.delete(`${this.apiUrl}/deletePermissionSet/` + id).pipe(
        map((response: any) => {
          return response;
        })
      )
    }
    public getAllPermissionSet(branchId: number, state: DataSourceRequestState): Observable<DataResult> {
      let params = {
        branchId: branchId,
        state: state
      }
      return this.httpClient.post(`${this.apiUrl}/getAllPermissionSet/`, params).pipe(
        map((response: any) => {
          return {
            data: response.data,
            total: response.total
          } as GridDataResult
        })
      ) as any as Observable<GridDataResult>
    }
    getPermissionSetByUserRole(roleId: number, branchId: number) {
      return this.httpClient.get(`${this.apiUrl}/getPermissionSetByRole/` + roleId + '/app/' + branchId).pipe(
        map((response: any) => {
          return response.data;
        })
      )
    }
    getPermissionSetById(id: number) {
      return this.httpClient.get(`${this.apiUrl}/getPermissionSetById/` + id).pipe(
        map((response: any) => {
          return response.data;
        })
      )
    }
  }